import { db } from "react-lib/frameworks/Firebase";
import { collection, doc, Firestore, getDoc } from "firebase/firestore";
import { getDownloadURL, getStorage, ref, uploadBytes } from "firebase/storage";

import { ParsedContent } from "./MeCastType";
import { getApp } from "firebase/app";

export const countImages = (content: string): number => {
  const div = document.createElement("div");
  div.innerHTML = content;
  return div.querySelectorAll("img").length;
};

export const countVideos = (content: string): number => {
  const div = document.createElement("div");
  div.innerHTML = content;
  return div.querySelectorAll("iframe").length;
};

export const countLinks = (content: string): number => {
  const div = document.createElement("div");
  div.innerHTML = content;
  return div.querySelectorAll("a").length;
};

export const getTextLength = (content: string): number => {
  const div = document.createElement("div");
  div.innerHTML = content;
  return div.textContent?.trim().length || 0;
};

export const getTotalVideoOrLink = (content: string): number =>
  countVideos(content) + countLinks(content);

export const parseBroadcastContent = (content: string): ParsedContent => {
  if (!content || typeof content !== "string") {
    return {
      previews_text: "",
      previews_picture: [],
      previews_video: [],
    };
  }

  const html = content;

  // ---------------------------
  // 1) Extract Images
  // ---------------------------
  const imageMatches = [...html.matchAll(/<img[^>]*src=["']([^"']+)["']/g)];
  const previews_picture = imageMatches.map(m => m[1]);

  // ---------------------------
  // 2) Extract Videos (iframes)
  // ---------------------------
  const videoMatches = [...html.matchAll(/<iframe[^>]*src=["']([^"']+)["']/g)];
  const previews_video = videoMatches.map(m => m[1]);

  // ---------------------------
  // 3) Extract Text
  // ---------------------------

  let text = html;

  // Remove images
  text = text.replace(/<img[\s\S]*?>/g, '');

  // Remove iframes
  text = text.replace(/<iframe[\s\S]*?<\/iframe>/g, '');

  // Remove figure blocks
  text = text.replace(/<figure[\s\S]*?<\/figure>/g, '');

  // Strip all HTML tags
  text = text.replace(/<[^>]+>/g, '');

  // Trim whitespace
  const previews_text = text.trim();

  return {
    previews_text,
    previews_picture,
    previews_video,
  };
};

export const base64ToBlob = (base64: string) => {
  const byteString = atob(base64.split(",")[1]);
  const mimeString = base64.split(",")[0].split(":")[1].split(";")[0];

  const ab = new ArrayBuffer(byteString.length);
  const ia = new Uint8Array(ab);
  for (let i = 0; i < byteString.length; i++) {
    ia[i] = byteString.charCodeAt(i);
  }

  return new Blob([ab], { type: mimeString });
};

export const uploadBase64Image = async (base64: string, storagePath: string) => {
  const firebaseApp = getApp();
  const storage = getStorage(firebaseApp, storagePath);
  const blob = base64ToBlob(base64);

  const filename = `broadcast_images/${Date.now()}_${Math.random().toString(36).slice(2)}.png`;
  const storageRef = ref(storage, filename);

  await uploadBytes(storageRef, blob);

  return await getDownloadURL(storageRef);
};

export const replaceB64ImageWithUrls = async (html: string, storagePath: string) => {
  const wrapper = document.createElement("div");
  wrapper.innerHTML = html;

  const imgTags = wrapper.querySelectorAll("img");

  for (let img of imgTags) {
    const src = img.getAttribute("src") || "";
    if (src.startsWith("data:image/")) {
      const url = await uploadBase64Image(src, storagePath);
      img.setAttribute("src", url);
    }
  }

  return wrapper.innerHTML;
};

export const getPostById = async (collectionName: string, postId: string) => {
  try {
    const docRef = doc(collection(db as Firestore, collectionName), postId);
    const docSnap = await getDoc(docRef);

    if (docSnap.exists()) {
      // console.log("Post data:", docSnap.data());
      return docSnap.data();
    } else {
      console.warn("[getPostById] Post not found!!");
      return null;
    }
  } catch (error) {
    console.error("[getPostById] Error getting post:", error);
    throw error;
  }
};
